module.exports = __webpack_public_path__ + "images/Luckin_coffee-3b884c.png";